
import { useQuery } from "@tanstack/react-query";
import { getItemsNew } from "src/api";
import { placeholder } from "src/assets/images";
import { useNavigate } from "react-router-dom";
import { useProtectedRoutesContext } from "src/context/ProtectedRoutes";
import { renderCurrency } from "../renderCurrency";



const AllProducts = () => {
    const { conversionRates } = useProtectedRoutesContext()
    const navigate = useNavigate();


    const { data: itemsNew } = useQuery
        ({
            queryKey: ["getItemsNew"],
            queryFn: () => getItemsNew(),
        });

    return (
        <div className="py-4">
            {itemsNew?.data && itemsNew.data.length > 0 ?
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-3">
                    {itemsNew?.data?.map((product) => {
                        const imageUrl = product.itemImages?.length > 0
                            ? product.itemImages[0].url
                            : placeholder; // Replace with your actual placeholder image path

                        return ( // ✅ Ensure we return JSX
                            <div key={product.id} className="relative group touch-browse-val" onClick={() => {
                                navigate(`/product/${product.id}`);
                                window.scrollTo(0, 0);
                            }}>
                                {/* Product Image */}
                                <div className="relative w-full h-[300px] overflow-hidden">
                                    {/* Default Image */}
                                    <img
                                        src={imageUrl}
                                        alt={product.design_number}
                                        className="w-full h-[300px] object-cover transition-opacity duration-300 group-hover:opacity-0 rounded-lg"
                                    />
                                    {/* Hover Image */}
                                    <img
                                        src={imageUrl}
                                        alt={product.design_number}
                                        className="absolute inset-0 w-full h-[300px] object-cover opacity-0 transition-opacity duration-300 group-hover:opacity-100 rounded-lg"
                                    />


                                </div>
                                <div className="flex justify-between items-center mt-2">
                                    <span className="text-sm font-semibold african-fatix-product-name">{product?.design_number}</span>
                                    <span className="text-sm font-medium text-gray-600 african-fatix-product-subname">{renderCurrency(product?.grade?.price * conversionRates[product.materialId])}</span>
                                </div>
                            </div>
                        );
                    })}
                </div>
                :
                <div className="no-data-value-stat mb-[100px] mt-[50px]">
                    {/* <h1 className="mb-[20px]">No New Arrival Currently</h1> */}
                    <a className="text-white px-20 py-3 rounded-lg shop-class " href="/shop">
                        Go to Shop
                    </a>
                </div>
            }
        </div>

    );
}

export default AllProducts;